import {useMutation, useQuery} from '@tanstack/react-query';
import {useLocalizedNavigation} from 'hooks';
import {RoutePath, unprotectedRoutes} from 'constants/app.constants';
import {getSelf, invite} from 'services/axios/modules';

export const useSelf = () => {
  const localizedNavigate = useLocalizedNavigation();
  return useQuery(
    ['me'],
    () => {
      return getSelf();
    },
    {
      onError: (error: any) => {
        const isUnprotectedRoute = unprotectedRoutes.some((route) => window.location.pathname.includes(route));
        if ([401, 403].includes(error?.status) && !isUnprotectedRoute) {
          localStorage.removeItem('userSession');
          localizedNavigate(RoutePath.login);
        }
      },
    }
  );
};

export const useInvite = () => {
  return useMutation({
    mutationFn: (data: {email: string; firstName: string; lastName: string; role: string}) => {
      return invite(data);
    },
  });
};
